import { getConsent } from "@asosteam/asos-web-consent";
import getCustomerGuid from "./getCustomerGuid";
import getSessionId from "./getSessionId";

const buildParamsFromIdentity = async (identityPromise) => {
  const { C0004 } = getConsent();

  if (!C0004) {
    return { block: 1 };
  }

  const customerId = await getCustomerGuid(identityPromise);
  const retailerVisitorId = getSessionId();

  return {
    block: 0,
    customerId,
    retailerVisitorId
  };
};

export default buildParamsFromIdentity;
